import { Injectable } from '@angular/core';

import { GlobalStateService } from '../services/state/global-state';

@Injectable({
	providedIn: 'root',
})
export class GlobalStateResolver {
	constructor(private globalStateService: GlobalStateService) {}

	async resolve() {
		await this.globalStateService.initState();
		return true;
	}
}
